import { Modal, ModalBody } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Button } from "@vds/buttons";
import { Checkbox } from "@vds/checkboxes";
import { Icon } from "@vds/icons";
import {
  ADD_GROUP_MODAL_TITLE_PREFIX,
  ADD_GROUP_MODAL_TITLE_SUFFIX,
  ADD_GROUP_MODAL_SITE_LABEL,
  ADD_GROUP_MODAL_BUTTON,
  ADD_GROUP_MODAL_NO_GROUPS_MESSAGE,
  ADD_GROUP_MODAL_NO_MEMBERS_MESSAGE
} from "../../global/constants/userDetailsConstants";

const AddGroupModal = ({
  opened,
  selectedSite,
  selectedGroups,
  onGroupSelection,
  onAddSelectedGroups,
  onClose,
  userName
}) => {
  const { groups, siteName } = selectedSite || {};

  const hasNewGroupsSelected = groups?.length > 0 && selectedGroups.some(
    (id) => !groups.find((group) => group.id === id)?.associated
  );

  const isAddButtonDisabled = !hasNewGroupsSelected;

  return (
    <Modal
      opened={opened}
      hideCloseButton={false}
      className="modal-groups"
      disableOutsideClick={true}
      onClose={onClose}
    >
      <Title size="large" bold primitive="h2" viewport="desktop">
        {ADD_GROUP_MODAL_TITLE_PREFIX} {userName} {ADD_GROUP_MODAL_TITLE_SUFFIX}
      </Title>
      <ModalBody>
        <Body size="medium" viewport="desktop" primitive="span">
          <p className="modal-site-info">
            {ADD_GROUP_MODAL_SITE_LABEL} <strong>{siteName}</strong>
          </p>
          <div className="modal-scrollable-content">
            {groups?.length > 0 &&
              groups?.map((group) => (
                <div key={group.id} className="group-item">
                  <Checkbox
                    label={group.name}
                    selected={selectedGroups.includes(group.id)}
                    disabled={group?.associated}
                    onChange={() => onGroupSelection(group.id)}
                    tabIndex="-1"
                  />

                  <div className="group-members">
                    {group.users && group.users.length > 0 ? (
                      <p>
                        {group.users.map((user, index) => (
                          <span key={user.id}>
                            {user?.name}
                            {user.id !==
                              group.users[group.users.length - 1].id && ", "}
                          </span>
                        ))}
                      </p>
                    ) : (
                      <p>{ADD_GROUP_MODAL_NO_MEMBERS_MESSAGE}</p>
                    )}
                  </div>
                </div>
              ))}
          </div>
          {groups?.length > 0 ? (
            <div className="button-add-groups-container">
              <Button
                className="button-add-groups"
                disabled={isAddButtonDisabled}
                data-testid="userdetails_addSelectedGroupsButton"
                onClick={onAddSelectedGroups}
              >
                {ADD_GROUP_MODAL_BUTTON}
              </Button>
            </div>
          ) : (
            <p>{ADD_GROUP_MODAL_NO_GROUPS_MESSAGE}</p>
          )}
        </Body>
      </ModalBody>
    </Modal>
  );
};

export default AddGroupModal;
